document.addEventListener('DOMContentLoaded', function() {
    MicroModal.init({
        // Custom options
        // debugMode: true // Enable debug mode (console output for debugging)
    })

    // make sure when the product clicks, it feeds product information through the product
    async function fillModal(productId) {
        try {
            const response = await fetch(`/products/${productId}.js`)
            if (!response.ok) {
                throw new Error('Network response was not ok')
            }

            const productData = await response.json()

            console.log(productData)

            // Fill modal content with product data
            document.getElementById('product-modal-title').innerText = productData.title;
            document.getElementById('product-modal-price').innerText = productData.price ? (parseFloat(productData.price) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '$0.00';
            document.getElementById('product-modal-description').innerHTML = productData.description;
            document.getElementById('product-modal-vendor').innerText = productData.vendor;
            document.getElementById('product-modal-image').src = productData.images[0];
            document.getElementById('product-modal-image').alt = productData.title;
            document.getElementById('product-modal-type').alt = productData.type ? productData.type : "";
            document.getElementById('product-modal-link').href = `/products/${productId}`;
            document.getElementById('product-modal-sku').innerText = productData.variants[0].sku ?  productData.variants[0].sku : "";

            if (!productData.available) {
                document.getElementById('ProductSubmitButton-template--modal-main').disabled = true;
                document.getElementById('ProductSubmitButton-template--modal-main').innerHTML = "<span>Sold out</span>";
            } else {
                document.getElementById('ProductSubmitButton-template--modal-main').disabled = false;
                document.getElementById('ProductSubmitButton-template--modal-main').innerHTML = "<span>Add to cart</span><div class='loading__spinner hidden'> <svg aria-hidden='true' focusable='false' class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'> <circle class='path' fill='none' stroke-width='6' cx='33' cy='33' r='30'></circle> </svg> </div>";
            }

            let variantId = productData.id
            if(productData.variants) { // Check if there are multiple variants
                variants = productData.variants
                variants.forEach((item, index) => {
                    if (item.available && index === 0) {
                        variantId = item.id
                    }
                })
            }
            const productIdInput = document.querySelector('.modal-content-row input[name="id"]');
            if (productIdInput) {
                productIdInput.value = variantId
            }

            // Fill in other product information with attached metafields
            const productStyle = document.getElementById(`${productId}-style`);
            const productAlcoholContent = document.getElementById(`${productId}-alcohol_content`);
            const productCountry = document.getElementById(`${productId}-country`);
            const productStandardDrinks = document.getElementById(`${productId}-standard_drinks`);
            const productType = document.getElementById(`${productId}-type`);
            const productSize = document.getElementById(`${productId}-size`);

            document.getElementById('product-modal-style').innerText = productStyle.value ? productStyle.value : 'None';
            document.getElementById('product-modal-alcohol_content').innerText = productAlcoholContent.value ? productAlcoholContent.value : 'None';
            document.getElementById('product-modal-country').innerText = productCountry.value ? productCountry.value : 'None';
            document.getElementById('product-modal-standard_drinks').innerText = productStandardDrinks.value ? productStandardDrinks.value : 'None';
            document.getElementById('product-modal-type').innerText = productType.value ? productType.value : 'None';
            document.getElementById('product-modal-size').innerText = productSize.value ? productSize.value : 'None';

            var clone = document.getElementById(`${productId}-select`); // Fill in the size choices
            if (clone) {
                var productSelect = document.getElementById('product-select');
                productSelect.innerHTML = '';
                // Loop through the children of 'product-select-clone' and clone them
                clone.childNodes.forEach(function(child) {
                    var clonedChild = child.cloneNode(true); // Deep clone the child
                    productSelect.appendChild(clonedChild); // Append the cloned child
                });

                document.getElementById('select-size-section').style.display = 'flex';
            } else {
                document.getElementById('select-size-section').style.display = 'none';
            }

            // Show the modal
            MicroModal.show('product-card-modal');
        } catch (error) {
            console.error('There has been a problem with your fetch operation:', error);
        }
    }

    // Attach click event listener to a parent element (e.g., document or a container)
    document.addEventListener('click', function(event) {
        // Check if the clicked element is a product card
        const wrapper = event.target.closest('.default-content');
        if (wrapper) {
            const card = event.target.closest('.product-card-wrapper');
            const productHandle = card.getAttribute('data-product-handle');
            fillModal(productHandle);
        }
    });

    // Get the select element with ID 'product-select-id'
    document.addEventListener('change', function(event) {
        if (event.target && event.target.id === 'product-select') {
            // Update price first
            var selectedOption = event.target.options[event.target.selectedIndex];
            var price = selectedOption.getAttribute('data-price');
            console.log(price)
            if (price !== null) {
                var formattedPrice = `$${(parseFloat(price) / 100).toFixed(2)}`;
                document.getElementById('product-modal-price').innerText = formattedPrice;
            }

            // Update variant id 
            var selectedValue = event.target.value;
            var inputElement = document.querySelector('.modal-content-row input[name="id"]');
            if (inputElement) {
                inputElement.value = selectedValue;
            }
        }
    });

    // Get the element with ID 'Quantity-template--modal-main'
    var quantityElement = document.getElementById('Quantity-template--modal-main');
    var quantityInput = document.getElementById('quantity');
    if (quantityElement && quantityInput) {
        quantityElement.addEventListener('change', function() {
            // Update the value of the input field with ID 'quantity'
            quantityInput.value = quantityElement.value;
        });
    }

    // Quick Edit quantity
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.edit-quantity-btn');
      if (!button) return;
    
      console.log('clicked');
      e.preventDefault();
      e.stopPropagation();
    
      // Remove focus from button
      button.blur();
    
      const parent = button.closest('.product-card-wrapper');
      if (!parent) {
        console.warn('No .product-card-wrapper found');
        return;
      }
    
      const wrapper = parent.querySelector('.card-content-wrapper');
      if (!wrapper) {
        console.warn('.card-content-wrapper not found inside parent');
        return;
      }
    
      const currentType = wrapper.getAttribute('data-type');
      const newType = currentType === 'edit-quantity' ? 'default' : 'edit-quantity';
      wrapper.setAttribute('data-type', newType);
    
      button.classList.toggle('button--primary');
      button.classList.toggle('button--secondary');
    
      button.textContent = newType === 'edit-quantity' ? 'Cancel' : 'Add to cart';
    });


     // Add event listener to .quantity__input for 'change' event
    //  document.querySelectorAll('.edit-quantity-wrapper .quantity__input').forEach(input => {
    //   input.addEventListener('change', function () {
    //     // console.log('change input')
    //     // Find the closest input with the name "quantity" in the same form
    //     const quantityInput = this.closest('.edit-quantity-wrapper').querySelector('input[name="quantity"]');
        
    //     // If the corresponding quantity input is found, set its value
    //     if (quantityInput) {
    //       quantityInput.value = this.value;
    //     }
    //   });
    // });
      document.addEventListener('change', function (e) {
      // Check if the changed element is a quantity__input inside .edit-quantity-wrapper
      if (e.target.matches('.edit-quantity-wrapper .quantity__input')) {
        const input = e.target;
        const allWrappers = document.querySelectorAll('.edit-quantity-wrapper');
    
        // Remove 'active' from all wrappers
        allWrappers.forEach(wrapper => wrapper.classList.remove('active'));
    
        // Find and activate the current wrapper
        const currentWrapper = input.closest('.edit-quantity-wrapper');
        if (currentWrapper) {
          currentWrapper.classList.add('active');
    
          // Update the hidden/form quantity input
          const quantityInput = currentWrapper.querySelector('input[name="quantity"]');
          if (quantityInput) {
            quantityInput.value = input.value;
          }
        }
      }
    });

    // Attach a click event listener to all buttons with class "quantity__button"
    let debounceTimeout = null;
    // document.querySelectorAll(".edit-quantity-wrapper .quantity__input").forEach(button => {
    //   button.addEventListener("change", () => {
    //     const dataId = button.getAttribute("data-id");
    //     if (dataId) {
    //       // Find the corresponding add__submit button with the class "add__submit-{dataId}"
    //       const targetButton = document.querySelector(`.add__submit-${dataId}`);
    //       if (targetButton) { // only trigger if quantity button is stopped being spammed
    //         if (debounceTimeout) {
    //           clearTimeout(debounceTimeout);  // Clear the previous timeout
    //         }

    //         debounceTimeout = setTimeout(function() {
    //           // Make the API call after the user stops interacting with the buttons
    //           targetButton.click();
    //         }, 300);  // 300ms debounce delay
    //       } else {
    //         console.warn(`No button found with class 'add__submit-${dataId}'`);
    //       }
    //     } else {
    //       console.warn("No data-id attribute found on clicked button");
    //     }
    //   });
    // });

    document.addEventListener("change", function (e) {
      const input = e.target.closest(".edit-quantity-wrapper .quantity__input");
      if (!input) return;
    
      const dataId = input.getAttribute("data-id");
      if (dataId) {
        const targetButton = document.querySelector(`.add__submit-${dataId}`);
        if (targetButton) {
          if (debounceTimeout) {
            clearTimeout(debounceTimeout);
          }
    
          debounceTimeout = setTimeout(function () {
            targetButton.click();
          }, 300); // 300ms debounce
        } else {
          console.warn(`No button found with class 'add__submit-${dataId}'`);
        }
      } else {
        console.warn("No data-id attribute found on changed input");
      }
    });

    // Dynamically update value of the input
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          const variantId = item.variant_id;
          const quantity = item.quantity;
    
          // Construct expected input name
          const inputName = `quantity-${variantId}`;
    
          // Look for the input field inside a .edit-quantity-wrapper
          document.querySelectorAll(`.edit-quantity-wrapper input[name="${inputName}"]`).forEach(input => {
            if (input) {
              input.value = quantity; // Set the input value to match the cart quantity
            }
          });
        });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
})